import useAuth from './useAuth';

/**
 * Enable every experimental feature on dev mode.
 */
export default function useFeature(featureFlagName: string) {
	const auth = useAuth();
	const currentUserEmail = auth.getCurrentUser().email;

	// TimeTime users can see everything
	if (currentUserEmail.includes('timetime')) {
		return true;
	}

	if (featureFlagName === 'resources') {
		if (currentUserEmail === 'jalbarracin@esteticsoft.com') {
			return true;
		}
		if (currentUserEmail === 'julia@solublestudio.com') {
			return true;
		}
		return false;
	}

	if (featureFlagName === 'REMINDERS') {
		return false;
	}

	return false;
}
